import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { markAttan, verifyEmailOtp } from "../../ApiServices/ApiServices";
import { handleError, handleSuccess } from "../../Utils";

const VerifyContestOtp = ({ setShowModal, email }) => {
  const [passkey, setPasskey] = useState("");
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({ passkey: "", otp: "" });

  const handleGo = async () => {
    try {
      const newErrors = { passkey: "", otp: "" };

      if (!passkey.trim()) newErrors.passkey = "Passkey is required.";
      if (!otp.trim()) newErrors.otp = "OTP is required.";

      setErrors(newErrors);

      if (!newErrors.passkey && !newErrors.otp) {
        const response = await verifyEmailOtp(passkey, otp);
        handleSuccess(response?.message);
        setShowModal(false);
        // mark the attendance 
        await markAttan(email);
        
        // Redirect to contest
        window.open("https://www.hackerearth.com/dev-clubs-codesprint-20-test", "_blank");
      }
    } catch (error) {
      return handleError(error?.response?.data?.message);
    }
  };

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white relative rounded-xl shadow-xl w-full max-w-md p-6 m-2">
          {/* Close Button */}
          <button
            onClick={() => setShowModal(false)}
            className="absolute top-3 right-3 text-gray-500 hover:text-red-500 text-xl font-bold"
            aria-label="Close"
          >
            <CloseIcon />
          </button>

          <h2 className="text-2xl font-semibold text-center mb-6 text-gray-800">
            Verify OTP
          </h2>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Passkey
            </label>
            <input
              type="text"
              value={passkey}
              onChange={(e) => setPasskey(e.target.value)}
              placeholder="Enter Passkey"
              className={`w-full px-4 py-2 border ${
                errors.passkey ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 ${
                errors.passkey ? "focus:ring-red-400" : "focus:ring-green-400"
              }`}
            />
            {errors.passkey && (
              <p className="text-sm text-red-500 mt-1">{errors.passkey}</p>
            )}
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              OTP
            </label>
            <input
              type="text"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP"
              className={`w-full px-4 py-2 border ${
                errors.otp ? "border-red-500" : "border-gray-300"
              } rounded-lg focus:outline-none focus:ring-2 ${
                errors.otp ? "focus:ring-red-400" : "focus:ring-green-400"
              }`}
            />
            {errors.otp && (
              <p className="text-sm text-red-500 mt-1">{errors.otp}</p>
            )}
          </div>

          <button
            onClick={handleGo}
            className="w-full mt-4 py-2 bg-green-500 text-white font-medium rounded-lg hover:bg-green-600 transition duration-300"
          >
            Go
          </button>
        </div>
      </div>
    </>
  );
};

export default VerifyContestOtp;
